// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:29
import { Agency_abstract } from './../../abstract/SagaBase/Objects/Agency_abstract';
export class Agency extends Agency_abstract {}
